import { Outlet } from 'react-router-dom';

import { BRANDING } from '@perplexicon/config';

import { useCurrentUser } from '../lib/auth.js';
import { Header } from './Header.js';

/** Shared dark frame and parchment workspace for every platform and game route. */
export function AppShell() {
  const { data: user } = useCurrentUser();

  return (
    <div className="flex min-h-dvh flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main
        id="main-content"
        tabIndex={-1}
        className="mx-auto w-full max-w-shell flex-1 px-0 py-0 tablet:px-5 tablet:py-6 wide:px-8"
      >
        <div className="min-h-full">
          <Outlet />
        </div>
      </main>
      {/*
        The tagline belongs to the public face of the product. Inside the
        signed-in application it is only vertical space beneath the player's
        own dashboard, so the footer keeps its layout slot and drops the copy.
      */}
      <footer className="mx-auto w-full max-w-shell px-4 py-5 text-center text-xs text-textOnDarkMuted">
        {user ? null : BRANDING.tagline}
      </footer>
    </div>
  );
}
